import Insights from './Insights'
import RenderInsights from './RenderInsights'
import DnsRequestInsights from './DnsRequestInsights'
import LogonFailureInsights from './LogonFailureInsights'
import ExternalConnectionInsights from './ExternalConnectionInsights'
import PrivilegedExecutionInsights from './PrivilegedExecutionInsights'

export {
  Insights,
  RenderInsights,
  DnsRequestInsights,
  ExternalConnectionInsights,
  LogonFailureInsights,
  PrivilegedExecutionInsights
}



// WEBPACK FOOTER //
// ./src/views/insights/index.js